// extracted by mini-css-extract-plugin
export default {"root":"Frame_root__WGmbk"};